import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../data/mock';
import { Utensils, ShoppingBag, Trees } from 'lucide-react';

const BBQ = () => {
  const { t } = useLanguage();

  const features = [
    { icon: <Utensils size={24} />, text: t('bbq1') },
    { icon: <ShoppingBag size={24} />, text: t('bbq2') },
    { icon: <Trees size={24} />, text: t('bbq3') }
  ];

  return (
    <section className="bg-[#121212] py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Image */}
          <div className="relative overflow-hidden" style={{ aspectRatio: '4/3' }}>
            <img 
              src={images.rooftopBalcony} 
              alt="BBQ"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          
          {/* Content */}
          <div className="lg:pl-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 leading-tight">
              {t('bbqTitle')}
            </h2>
            
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#00FFD1]/10 text-[#00FFD1]">
                    {feature.icon}
                  </div>
                  <span className="text-white/90 text-lg">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BBQ;